import { RecommendationInterface } from 'app/recommendation/models';

export interface AssessmentAnalysisInterface {
  unablesCount?: number;
  riskScore?: number;
  overallDiscomfort?: string;
  recommendations?: RecommendationInterface[];
}

export class AssessmentAnalysis implements AssessmentAnalysisInterface {
  public unablesCount?: number;
  public riskScore?: number;
  public overallDiscomfort?: string;
  public recommendations?: RecommendationInterface[];

  constructor({
    unablesCount = undefined,
    riskScore = undefined,
    overallDiscomfort = undefined,
    recommendations = undefined,
    }: AssessmentAnalysisInterface) {
    this.unablesCount = unablesCount;
    this.riskScore = riskScore;
    this.overallDiscomfort = overallDiscomfort;
    this.recommendations = recommendations;
  }
}
